import { useReveal } from "@/hooks/useReveal";

const CARDS = [
  {
    img: "https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/18466071-27ae-4da1-937a-11084a6f44f2_compressed_single-serve-sachet.webp",
    alt: "Single kraft paper sachet of organic whole cane sugar",
    title: "Single-serve sachet",
    line1: "Organic whole cane sugar. Portion weight 0.17 oz or 5 g.",
    line2: "Custom printed with your brand, or unbranded.",
  },
  {
    img: "https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/4ca73dc0-f6c0-44d0-b8ed-af4aab8cfb38_compressed_table-caddy-pack.webp",
    alt: "Wooden condiment caddy holding rows of sugar sachets on a café table",
    title: "Table caddy pack",
    line1: "Sachets in retail-ready display boxes for the counter, the table and room service trays.",
    line2: "",
  },
  {
    img: "https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/9d76dcbd-5f73-4ad6-ab90-508ce7a77206_compressed_kitchen-and-bar-bulk.webp",
    alt: "Unbranded kraft foodservice bags of organic cane sugar with golden crystals",
    title: "Kitchen and bar bulk",
    line1: "Organic whole cane sugar, pulverised or granulated, in 5 kg foodservice bags and 25 kg sacks for the pastry section and the bar.",
    line2: "",
  },
  {
    img: "https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/b58550ea-1848-4832-865a-44eee513d346_compressed_organic-cocoa-powder.webp",
    alt: "Dark organic cocoa powder in a small bowl with a wooden spoon",
    title: "Cocoa powder",
    line1: "Organic cocoa powder at 15% fat, in foodservice packs and 25 kg bulk.",
    line2: "",
  },
];

export default function Formats() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section id="formats" className="bg-white py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal max-w-2xl">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            Formats
          </h2>
          <p className="mt-3 text-ink/70 text-lg">
            What we supply to hospitality, and in what shape.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {CARDS.map((card) => (
            <div
              key={card.title}
              className="bg-cream/60 rounded-lg overflow-hidden border border-cream-dark/50"
            >
              <div className="w-full h-96">
                <img
                  src={card.img}
                  alt={card.alt}
                  loading="lazy"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-ink font-serif text-lg md:text-xl font-semibold">
                  {card.title}
                </h3>
                <p className="mt-2 text-ink/70 text-[17px] leading-relaxed">
                  {card.line1}
                </p>
                {card.line2 && (
                  <p className="mt-1 text-ink/70 text-[17px] leading-relaxed">
                    {card.line2}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>

        <p className="mt-8 text-ink/70 text-[17px]">
          The sachets can be printed with your own brand, subject to prior
          negotiation regarding quantity and purchase frequency. Please consult
          the <a
            href="/private-label"
            className="text-brand font-semibold hover:underline"
          >
            private label
          </a>{" "}
          section to view the full range of available formats.
        </p>
      </div>
    </section>
  );
}